<div class="sidebar" [class.expanded]="expanded">
	<div class="sidebar-menu">
		<div class="menu-icon">
			<a class="menu-expand flex h-16 w-16 cursor-pointer items-center justify-center" (click)="onExpandedClick()">
				<div class="custom-menu">
					<div></div>
					<div></div>
					<div></div>
				</div>
			</a>
		</div>
		<div class="flex-1 px-6 py-2 lg:px-0 lg:py-6">
			<ul>
				<!-- <li>
        <div
          class="menu-wrapper"
          [class.active]="activePage === routeType.DASHBOARD"
          >
          <a class="menu" routerLink="{{ routeType.DASHBOARD }}">
            <div class="menu-icon">
              <img
                class="w-5"
                src="/assets/icon_sidebar_dashboard.svg"
                alt="dashboard"
                />
            </div>
            <div class="menu-label">Dasboard<span> Overview</span></div>
          </a>
        </div>
      </li> -->
				@if (rs.hasInstructorView) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.RATINGS">
							<button
								class="menu"
								routerLink="{{ routeType.RATINGS }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_rating.svg" alt="rating" />
								</div>
								<div class="menu-label">Ratings</div>
							</button>
						</div>
					</li>
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.PENDING">
							<button class="menu" routerLink="{{ routeType.PENDING }}">
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_forms.svg" alt="pending" />
								</div>
								<div class="menu-label">Pending Rating</div>
							</button>
						</div>
					</li>
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.REPORT">
							<button
								class="menu"
								routerLink="{{ routeType.REPORT }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_reports.svg" alt="reports" />
								</div>
								<div class="menu-label">Report<span> Management</span></div>
							</button>
						</div>
					</li>
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.MY_FEEDBACK">
							<button
								class="menu"
								routerLink="{{ routeType.MY_FEEDBACK }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_forms.svg" alt="feedback" />
								</div>
								<div class="menu-label">Feedback<span> History</span></div>
							</button>
						</div>
					</li>
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.CHECKLIST">
							<button
								class="menu"
								routerLink="{{ routeType.CHECKLIST }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_reports.svg" alt="action center" />
								</div>
								<div class="menu-label">Action Center</div>
							</button>
						</div>
					</li>
				}
				@if (rs.isAdmin || rs.isGroupAdmin) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.FORMS">
							<button
								class="menu"
								routerLink="{{ routeType.FORMS }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_forms.svg" alt="forms" />
								</div>
								<div class="menu-label">Form<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				@if (!rs.hasInstructorView) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.REPORT">
							<button
								class="menu"
								routerLink="{{ routeType.REPORT }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_reports.svg" alt="reports" />
								</div>
								<div class="menu-label">Report<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				@if (rs.isOfficeAdmin) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.PILOT_DATA">
							<button
								class="menu"
								routerLink="{{ routeType.PILOT_DATA }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_database.svg" width="20" alt="pilot data" />
								</div>
								<div class="menu-label">Pilot Data<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				@if (rs.isAdmin || rs.isGroupAdmin) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.FEEDBACK">
							<button
								class="menu"
								routerLink="{{ routeType.FEEDBACK }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_forms.svg" alt="feedback management" />
								</div>
								<div class="menu-label">Feedback<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				@if (rs.hasPilotView) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.MY_FEEDBACK">
							<button
								class="menu"
								routerLink="{{ routeType.MY_FEEDBACK }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_forms.svg" alt="feedback" />
								</div>
								<div class="menu-label">Feedback<span> History</span></div>
							</button>
						</div>
					</li>
				}
				@if (!rs.isGroupAdmin && !rs.isAdmin && !rs.isOfficeAdmin && !rs.hasInstructorView) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.CHECKLIST">
							<button
								class="menu"
								routerLink="{{ routeType.CHECKLIST }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_reports.svg" alt="action center" />
								</div>
								<div class="menu-label">Action Center</div>
							</button>
						</div>
					</li>
				}
				@if (rs.isAdmin) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.PILOT_DATA">
							<button
								class="menu"
								routerLink="{{ routeType.PILOT_DATA }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img src="/assets/icon_sidebar_database.svg" width="20" alt="pilot data" />
								</div>
								<div class="menu-label">Pilot Data<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				@if (rs.isAdmin) {
					<li>
						<div class="menu-wrapper" [class.active]="activePage === routeType.USER_MANAGEMENT">
							<button
								class="menu"
								routerLink="{{ routeType.USER_MANAGEMENT }}"
								[disabled]="!isOnline"
								[class.grayscale]="!isOnline"
								[class.cursor-not-allowed]="!isOnline"
							>
								<div class="menu-icon">
									<img class="w-5" src="/assets/icon_sidebar_user.svg" alt="user management" />
								</div>
								<div class="menu-label">User<span> Management</span></div>
							</button>
						</div>
					</li>
				}
				<!-- <li *ngIf="rs.isAdmin">
      <div
        class="menu-wrapper"
        [class.active]="activePage === routeType.INSTRUCTOR_VERIFICATION"
        >
        <a
          class="menu"
          routerLink="{{ routeType.INSTRUCTOR_VERIFICATION }}"
          >
          <div class="menu-icon">
            <img
              src="/assets/icon_sidebar_instructor_verification.svg"
              alt="instructor verification"
              />
          </div>
          <div class="menu-label">Instructor<span> Verification</span></div>
        </a>
      </div>
    </li> -->
			</ul>
		</div>
		<!-- <div>
<div class="menu-wrapper">
  <a class="menu" (click)="signout()">
    <div class="menu-icon">
      <img src="/assets/icon_sidebar_logout.svg" alt="logout" />
    </div>
    <div class="menu-label">Sign Out</div>
  </a>
</div>
</div> -->
	</div>
</div>
